import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectL: '',
    notiId: 0,
    idContenido: 0,
    rutaApi: 'https://stage.eaav.gov.co/api/'
  },
  getters: {
    getIdContenido: (state) => {
      return state.idContenido
    }
  },
  mutations: {
    chLanguage: (state, event) => state.selectL = event,
    SETIDCONTENIDO: (state, value) => {
      state.idContenido = value
    }
  },
  actions: {
    saveIdContenido ({ commit }, value) {
      commit('SETIDCONTENIDO', value)
    }
  }
})
